export function transformApiDataToOdontograma(apiData) {
  let inputsObject = {};

  if (apiData && apiData.inputs) {
    if (Array.isArray(apiData.inputs)) {
      apiData.inputs.forEach((input) => {
        inputsObject[input.name] = input.value || '';
      });
    } else if (typeof apiData.inputs === 'object') {
      inputsObject = apiData.inputs;
    }
  }

  const toothNumbers = [
    11, 12, 13, 14, 15, 16, 17, 18,
    21, 22, 23, 24, 25, 26, 27, 28,
    31, 32, 33, 34, 35, 36, 37, 38,
    41, 42, 43, 44, 45, 46, 47, 48,
    51, 52, 53, 54, 55,
    61, 62, 63, 64, 65,
    71, 72, 73, 74, 75,
    81, 82, 83, 84, 85,
  ];

  return toothNumbers.map((number) => {
    const surfacesKey = `tooth${number}Surfaces`;
    const conditionKey = `tooth${number}Condition`;
    const notesKey = `tooth${number}Notes`;

    const surfacesString = inputsObject[surfacesKey] || '';
    const surfaces = surfacesString
      ? surfacesString.split(',').map(s => s.trim()).filter(s => s)
      : [];

    return {
      number,
      condition: inputsObject[conditionKey] || '',
      notes: inputsObject[notesKey] || '',
      surfaces,
    };
  });
}

export function transformOdontogramaToApiData(teethArray, existingInputs = []) {
  const updatedValues = {};

  teethArray.forEach((tooth) => {
    const {
      number, condition, notes, surfaces,
    } = tooth;

    updatedValues[`tooth${number}Surfaces`] = surfaces && surfaces.length > 0
      ? surfaces.join(', ')
      : '';
    updatedValues[`tooth${number}Condition`] = condition || '';
    updatedValues[`tooth${number}Notes`] = notes || '';
  });

  const inputs = existingInputs.map(input => ({
    ...input,
    value: updatedValues[input.name] !== undefined ? updatedValues[input.name] : input.value,
  }));

  return inputs;
}
